/**
 * Maps a flat list of works onto the reference collage: 
 * Upgraded to a 4-row repeating block to accommodate two tall portrait cards 
 * without breaking the 3-column masonry grid logic.
 */
const SLOTS = [
  { col: 1, row: 1, span: 1 },
  { col: 2, row: 1, span: 1 },
  { col: 3, row: 1, span: 1 },
  { col: 1, row: 2, span: 1 }, // reserved for the brand tile in the first block
  { col: 2, row: 2, span: 1 },
  { col: 3, row: 2, span: 2 }, // Tall slot 1 (The Quiet Launch)
  { col: 2, row: 3, span: 2 }, // Tall slot 2 (Second Nature)
  { col: 1, row: 3, span: 1 },
  { col: 1, row: 4, span: 1 },
  { col: 3, row: 4, span: 1 },
];

const ROWS_PER_BLOCK = 4;

export const buildCollage = (works) => {
  const items = [
    {
      kind: "brand",
      key: "brand-tile",
      col: SLOTS[3].col,
      rowStart: SLOTS[3].row,
      rowSpan: SLOTS[3].span,
    },
  ];

  let workIndex = 0;
  let block = 0;

  while (workIndex < works.length) {
    for (let slot = 0; slot < SLOTS.length && workIndex < works.length; slot++) {
      if (block === 0 && slot === 3) continue; // brand tile already placed

      const shape = SLOTS[slot];
      items.push({
        kind: "media",
        key: works[workIndex].id,
        work: works[workIndex],
        col: shape.col,
        rowStart: block * ROWS_PER_BLOCK + shape.row,
        rowSpan: shape.span,
      });
      workIndex++;
    }
    block++;
  }

  // If the list runs out mid-block, the last tile can land in a tall (span 2)
  // slot with no tile left to sit beside its second row — that row reads as a
  // half-empty hole and the tall tile looks like an oversized orphan next to
  // its normal-sized neighbors. Drop it back to a normal single-row tile.
  const last = items[items.length - 1];
  if (last && last.rowSpan > 1) {
    last.rowSpan = 1;
  }

  return items;
};